// extracted by mini-css-extract-plugin
export default {"button":"ButtonIcon_button__7rcPn","xs":"ButtonIcon_xs__0mWfc","s":"ButtonIcon_s__vmNN8","m":"ButtonIcon_m__QoVn2","l":"ButtonIcon_l__PsZ6G"};